import { useState } from 'react';
import headerTitle from '../../assets/images/headerTitle.png'
import {
    ButtonHeaderRight,
    HeaderLink,
    HeaderWrapper,
    LogoWrapper,
    LinksWrapper
} from './styles'


const Header = () => {
    const [selectedItem, setSelectedItem] = useState('Home')

    return (
        <HeaderWrapper>
            <LogoWrapper>
                <img src={headerTitle} width={231} height={57} />
            </LogoWrapper>

            <LinksWrapper>
                <HeaderLink
                    isSelected={selectedItem === 'Home'}
                    onClick={() => setSelectedItem('Home')}
                >
                    Home
                </HeaderLink>
                <HeaderLink
                    isSelected={selectedItem === 'Features'}
                    onClick={() => setSelectedItem('Features')}>
                    Features
                </HeaderLink>
                <HeaderLink isSelected={selectedItem === 'Roadmap'} onClick={() => setSelectedItem('Roadmap')}>Roadmap</HeaderLink>
                <HeaderLink isSelected={selectedItem === 'Team'} onClick={() => setSelectedItem('Team')}>Team</HeaderLink>
                <ButtonHeaderRight>Join Our Discord</ButtonHeaderRight>
            </LinksWrapper>
        </HeaderWrapper>
    )
};

export default Header